import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { getReportByNamespaceApi } from '../api/customerApi';
import { getReportByNamespaceSuccess } from './actions';
import { GET_REPORT_BY_NAMESPACE_RETURN } from '../constants/action.types';
function* reportByNamespaceSaga({ payload }) {
  try {
    const res = yield call(
      getReportByNamespaceApi,
      payload.token,
      { namespace: payload.namespace },
      payload.dataQuery
    );
    if (res.status === 200) {
      yield put(getReportByNamespaceSuccess(res.data));
    }
  } catch (error) {
    console.log('error: ', error.response);
  }
}
function* reportByNamespaceWatcher() {
  yield takeLatest(GET_REPORT_BY_NAMESPACE_RETURN, reportByNamespaceSaga);
}

export default function* rootSaga() {
  yield all([fork(reportByNamespaceWatcher)]);
}
